import React, { useEffect, useState } from "react";
import { Paper, Grid, Typography, Divider } from "@mui/material";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { ModalButtons, ModalImages, useModal } from "context/modalContext";
import { authorizedGenApiCall } from "api/genApiCalls";
import { formatRequestObject } from "qubCommon/helperMethods/formatRequest";
import { FlexGrid } from "@grapecity/wijmo.react.grid";

const OrderInfo = ({ info }) => {
  const infoArray = formatRequestObject(info);
  return (
    <>
      {infoArray?.map((item) => {
        if (item?.dataKey !== "details")
          return (
            <React.Fragment key={item?.dataKey}>
              <Grid item xs={12} md={3} sx={{ paddingRight: { xs: 0, md: 2 } }}>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    textAlign: { xs: "center", md: "right" },
                  }}
                >
                  {item?.dataKey}
                </Typography>
              </Grid>
              <Grid item xs={12} md={9} sx={{ paddingRight: { xs: 0, md: 2 } }}>
                <Typography
                  sx={{
                    textAlign: { xs: "center", md: "left  " },
                  }}
                >
                  {item?.dataValue}
                </Typography>
              </Grid>
              <Grid container item xs={12} sx={{ justifyContent: "center" }}>
                <Divider sx={{ width: "94%" }} />
              </Grid>
            </React.Fragment>
          );
      })}
    </>
  );
};

const OrderView = () => {
  const { id } = useParams();
  const { openModal } = useModal();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [gridColumns, setGridColumns] = useState();

  async function fetchData(id) {
    const res = await authorizedGenApiCall({
      dataKey: "eShop-Orders-Expl",
      parameters: [{ dataKey: "OrderId", dataValue: id }],
    });
    let parsedData;
    try {
      parsedData = JSON.parse(res?.data);
      console.log(parsedData);
      setData(parsedData);
    } catch {
      openModal({
        title: "Σφάλμα Δεδομένων",
        message:
          "Παρουσιάστηκε σφάλμα κατα την λήψη των δεδομένων της παραγγελίας.\n\nΠαρακαλώ προσπαθείστε αργότερα! ",
        imageType: ModalImages.Error,
        buttons: ModalButtons.OK,
        callback: () => {
          navigate("/orders-expl");
        },
      });
    }
  }

  useEffect(() => {
    if (id) {
      setGridColumns([
        {
          binding: "GUID",
          header: "Αναγνωριστικό",
        },
        {
          binding: "order_detail_id",
          header: "Αριθμός Γραμμής Παραγγελίας",
        },
        {
          binding: "product_code",
          header: "Κωδικός Προϊόντος",
        },
        {
          binding: "product_size",
          header: "Μέγεθος",
          width: "*",
        },
      ]);
      fetchData(id);
    }
  }, [id]);

  console.log(data?.details, "debugHere");
  const gridInitialized = (flex) => {
    flex.selectionMode = "Row";

    flex.itemFormatter = (panel, r, c, cell) => {
      /* html + css for rowHeaders A/A */
      if (panel.cellType === 3) {
        cell.innerHTML = `<div class='row-header'> ${
          panel.rows[r]?.index + 1
        }</div>`;
      }

      // if (panel.rows[r]?.dataItem?.RecordMsg) {
      //   panel.rows[r].cssClass = "warning-message";
      // }
      /* date format */
      // wijmoDateFormat(panel, r, c, cell, "AppointmentDate", false, {
      //   d: 0,
      //   m: 1,
      //   y: 2,
      //   format: "dd/MM/yyyy",
      // });
    };
    flex.autoSizeColumns();
    // flex.columnHeaders.rows[0].visible = false;
  };

  if (data)
    return (
      <Grid container spacing={2} sx={{ padding: 4 }}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4">Στοιχεία παραγγελίας</Typography>
          </Grid>
          <Grid container item xs={12}>
            <OrderInfo info={data} />
          </Grid>
        </Grid>

        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h4">Ανάλυση παραγγελίας</Typography>
          </Grid>
          {data?.details && (
            <FlexGrid
              isReadOnly
              initialized={gridInitialized}
              itemsSource={data?.details}
              className="explorer-grid"
            />
          )}
        </Grid>
      </Grid>
    );
  else
    return (
      <Grid
        container
        spacing={2}
        sx={{ padding: 2, justifyContent: "center", alignItems: "center" }}
      />
    );
};

export default OrderView;
